import { z } from 'zod';
import { enrichableFieldSchema, severitySchema } from './enums';

/** Identificadores estáveis das regras determinísticas de auditoria. */
export const RULE_IDS = [
  'description.missing',
  'description.too_short',
  'description.duplicated',
  'description.keyword_stuffing',
  'metaTagDescription.missing',
  'metaTagDescription.too_short',
  'metaTagDescription.too_long',
  'title.missing',
  'title.too_long',
  'title.serp_too_long',
  'title.generic',
  'title.duplicated',
  'name.missing',
  'name.too_short',
  'name.generic',
  'name.too_long',
  'skuName.missing',
  'skuName.equals_product_name',
  'specifications.required_missing',
  'specifications.filterable_empty',
  'images.missing',
  'images.missing_alt_text',
  'images.missing_label',
  'apparel.missing_required_attribute',
  'sku.missing_ean',
  'sku.missing_measures',
] as const;
export const ruleIdSchema = z.enum(RULE_IDS);
export type RuleId = z.infer<typeof ruleIdSchema>;

export const findingSchema = z.object({
  ruleId: ruleIdSchema,
  field: enrichableFieldSchema.nullable(),
  severity: severitySchema,
  /** Mensagem pronta para o revisor, em português. */
  message: z.string(),
  /** SKU específico quando o problema é de SKU, `null` quando é do produto. */
  skuId: z.number().int().nullable(),
  /** Contexto estruturado da regra (valores medidos, limites, duplicatas). */
  details: z.record(z.string(), z.unknown()).default({}),
});
export type Finding = z.infer<typeof findingSchema>;

export const productScoreSchema = z.object({
  productId: z.number().int(),
  /** 0 a 100; 100 é catálogo sem nenhum finding. */
  score: z.number().min(0).max(100),
  penalty: z.number().min(0),
  findingsBySeverity: z.record(severitySchema, z.number().int()),
});
export type ProductScore = z.infer<typeof productScoreSchema>;
